import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { cn } from '~/lib/utils'
import { Button } from '~/lib/ui/button'
import { useBenefits } from '../BenefitsProvider'
import { useFormatTime } from '~/hooks/useFormatTime'
import CandidateChangeFormatDialog from './CandidateChangeFormatDialog'

export default function CalendlyEventInfo({
  eventName,
  calendlyEvent,
  dashboardCard,
  serviceRequestsPageCard,
  linkColor,
  buttonUrl,
  isResumeReview = false,
}) {
  const { t, locale } = useTranslation()
  const { onCancelClick, select, isReformattingLoading } = useBenefits()
  const formatTime = useFormatTime(locale)

  const { start_time, join_url, reschedule_url, cancel_url } = calendlyEvent
  const formattedStartTime = formatTime(start_time)
  return (
    <>
      {/* Re: isReformattingLoading below - this isn't the actual link, it loads the spinner from this component */}
      {isReformattingLoading ? (
        <CandidateChangeFormatDialog />
      ) : (
        <div>
          <div className="font-bold">
            {eventName} {t('service_card.scheduled')}
          </div>
          <div>{formattedStartTime}</div>
          {buttonUrl ? (
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-4 pt-4">
                <a
                  href={join_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={cn('text-link', dashboardCard ? 'flex-grow' : '')}
                >
                  <Button
                    variant={select ? 'outline' : 'coachcta'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cn('', dashboardCard ? 'w-full' : '')}
                  >
                    {t('service_card.join_meeting')}
                  </Button>
                </a>
                <a
                  href={buttonUrl}
                  className={cn('text-link', dashboardCard ? 'flex-grow' : '')}
                >
                  <Button
                    variant="outline"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cn('', dashboardCard ? 'w-full' : '')}
                  >
                    {t('service_card.view_details')}
                  </Button>
                </a>
              </div>
              <div className="flex flex-col gap-4">
                <a
                  href={reschedule_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => onCancelClick()}
                  className={cn(linkColor, 'text-link', 'hover:!underline')}
                >
                  {t('service_card.reschedule')}
                </a>
                <a
                  href={cancel_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => onCancelClick()}
                  className={cn(linkColor, 'text-link', 'hover:!underline')}
                >
                  {t('service_card.cancel')}
                </a>
                {isResumeReview &&
                  !serviceRequestsPageCard &&
                  !dashboardCard && <CandidateChangeFormatDialog />}
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-4 pt-4">
              <a
                href={join_url}
                target="_blank"
                rel="noopener noreferrer"
                className={cn('text-link', dashboardCard ? 'flex-grow' : '')}
              >
                <Button
                  variant={select ? 'outline' : 'coachcta'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={cn('', dashboardCard ? 'w-full' : '')}
                >
                  {t('service_card.join_meeting')}
                </Button>
              </a>
              <a
                href={reschedule_url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => onCancelClick()}
                className={cn(linkColor, 'text-link', 'hover:!underline')}
              >
                {t('service_card.reschedule')}
              </a>
              <a
                href={cancel_url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => onCancelClick()}
                className={cn(linkColor, 'text-link', 'hover:!underline')}
              >
                {t('service_card.cancel')}
              </a>
              {isResumeReview && <CandidateChangeFormatDialog />}
            </div>
          )}
        </div>
      )}
    </>
  )
}
